import _defineProperty from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";

var _props;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import debounce from 'quasar/src/utils/debounce.js';;
import * as Helpers from "@/helpers";
import VueNumeric from "vue-numeric";
export default {
  name: "MoneyInput",
  components: {
    VueNumeric: VueNumeric
  },
  computed: {
    readOnlyValue: function readOnlyValue() {
      return Helpers.MoneyHelper.GetMoneyReadValue(this.value, 0, ".", ",");
    },
    computedClass: function computedClass() {
      return "q-pa-none print-hide " + this.class;
    },
    isDirty: function isDirty() {
      return this.value != "" && this.value != null && this.value != this.originalValue;
    }
  },
  props: (_props = {
    autofocus: {
      type: Boolean,
      default: false
    },
    appendIcon: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String
    },
    error: {
      type: Boolean
    },
    errorMessage: {
      type: String
    },
    borderless: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: true
    },
    filled: {
      type: Boolean
    },
    readOnly: {
      default: false
    },
    disable: {
      default: false
    },
    dense: {
      type: Boolean,
      dense: true
    },
    value: {},
    prefix: {
      type: String,
      default: null
    }
  }, _defineProperty(_props, "filled", {
    type: Boolean
  }), _defineProperty(_props, "color", {
    type: String,
    default: "black"
  }), _defineProperty(_props, "BGColor", {
    type: String,
    default: "white"
  }), _defineProperty(_props, "size", {
    type: String,
    default: "10px"
  }), _defineProperty(_props, "clearable", {
    type: Boolean,
    default: false
  }), _defineProperty(_props, "rounded", {
    type: Boolean
  }), _defineProperty(_props, "tooltip", {
    type: Boolean
  }), _defineProperty(_props, "toolValue", {
    type: String,
    default: "Add toolValue prop to change text"
  }), _defineProperty(_props, "label", {
    type: String
  }), _defineProperty(_props, "hint", {
    type: String
  }), _defineProperty(_props, "inputStyle", {
    type: String
  }), _defineProperty(_props, "required", {
    type: Boolean,
    default: false
  }), _defineProperty(_props, "requirePositive", {
    type: Boolean,
    default: false
  }), _defineProperty(_props, "requireNegative", {
    type: Boolean,
    default: false
  }), _defineProperty(_props, "rules", {
    type: Array
  }), _defineProperty(_props, "mask", {
    type: String,
    default: ""
  }), _defineProperty(_props, "round", {
    type: Boolean,
    default: true
  }), _defineProperty(_props, "roundReadOnly", {
    type: Boolean,
    default: false
  }), _defineProperty(_props, "clickToEdit", {
    default: false
  }), _props),
  data: function data() {
    return {
      Helpers: Helpers,
      clicked: false,
      loaded: false,
      originalValue: null
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.emit = debounce(this.emit, 100);
    this.originalValue = this.value;
  },
  methods: {
    isRequired: function isRequired() {
      if (this.required && (this.value == null || isNaN(this.value))) return "*Field is required";else if (this.required && this.requirePositive && this.value <= 0) return "*Field is required";else if (this.requireNegative && this.value > 0) return "*Negative or Zero Amount is required";else return true;
    },
    validate: function validate() {
      return this.$refs.input.validate();
    },
    emit: function emit($event) {
      this.$emit("input", $event);
    },
    resetDirty: function resetDirty() {
      this.originalValue = this.value;
    }
  }
};